import React, { useEffect } from "react";
import { reduxForm } from "redux-form";
import { HUMAN_RESOURCES, ROLE_ADMIN } from "../../../../utility/constants";
import Filters from "../../Utils/Filters/Filters";
import Grid from "../../Utils/Grid";
import { standardActions } from "../../Utils/Grid/StandardActions";
import Title from "../../Utils/Headers/Title";
import "./style.css";

const List = (props) => {
    const {
        customUserList,
        setStation,
        station,
        setUser,
        user_,
        data,
        loader,
        setStartDate,
        start_date,
        setEndDate,
        end_date,
    } = props;

    useEffect(() => {
        props.customUserList();
    }, []);

    // Minutes to hors (1hrs 0min)
    const converter = (minutes) => {
        const hours = Math.floor(minutes / 60);
        const minutes_ = minutes % 60;
        return `${hours}hrs ${minutes_}min`;
    };

    const columns = [
        {
            dataField: "first_name",
            text: "Nombre",
            formatter: (cell, row) => `${cell} ${row.last_name}`,
        },

        {
            dataField: "firefighter_type",
            text: "Tipo",
            formatter: (cell) => {
                let className = "pill-hours-control pill-hc-type";
                if (cell && cell.toLowerCase().includes("permanente")) {
                    className = "pill-hours-control pill-hc-permanent";
                }
                return <span className={className}>{cell}</span>;
            },
        },

        {
            dataField: "status",
            text: "Estado",
            formatter: (cell, row) => {
                let status = "Sin estado";
                let className = "pill-hours-control";

                if (row.status === "Activo") {
                    status = "De alta";
                    className += " pill-hc-active";
                } else if (row.status === "Inactivo") {
                    status = `De baja`; // Compact text for pill, optionally keep reason on hover or separate
                    if (row.inactive_reason) status += ` (${row.inactive_reason})`; // Keeping original logic for now

                    if (row.inactive_reason && row.inactive_reason.toLowerCase().includes("renuncia")) {
                        className += " pill-hc-resigned";
                    } else {
                        className += " pill-hc-inactive";
                    }
                }
                return <span className={className}>{status}</span>;
            },
        },

        {
            dataField: "station_text",
            text: "Estacion",
        },

        {
            dataField: "total_hours_day",
            text:
                end_date && start_date
                    ? "Total en rango"
                    : "Total hoy",
            formatter: (cell, row) => {
                if (row.total_hours_day || row.total_hours_day === 0) {
                    return (
                        <span className="pill-hours-control pill-hc-type" style={{ backgroundColor: '#e2e6ea', color: '#495057' }}>
                            {converter(row.total_hours_day)}
                        </span>
                    );
                } else {
                    return (
                        <span className="pill-hours-control pill-hc-none">
                            Sin registro
                        </span>
                    );
                }
            }
        },

        {
            dataField: "total_minutes_overall",
            text: "Total histórico",
            formatter: (cell) => (
                <span className="pill-hours-control pill-hc-permanent">
                    {converter(cell || 0)}
                </span>
            )
        },

        {
            dataField: "id",
            text: "Acciones",
            formatter: (cell, row) =>
                standardActions({
                    ver: "/human_resources/control_hours/detail",
                })(cell, row),
        },
    ];

    // Calculation grand total — prioritize backend provided global totals
    let grandTotal = 0;
    if (data && data.results) {
        if (start_date && end_date) {
            grandTotal = data.grand_total_in_range || 0;
        } else {
            grandTotal = data.grand_total_overall || 0;
        }
        
        // Fallback for security (though highly recommended to rely on backend totals for filtered lists)
        if (grandTotal === 0 && data.results.length > 0) {
            // Only if backend didn't provide it, or it really is 0 but we want to be sure
            // However, with 2119 results, 0 from backend is more likely correct than sum of 10 rows
        }
    }

    return (
        <div className="py-4">
            <div className="row">
                <div className="mb-4 col-lg-12">
                    <div className="mb-4 card card-small">
                        <div className="px-3 pt-4">
                            <Title
                                title={"Control de horas"}
                                subtitle={"Listado general"}
                                total={{
                                    title: "Total de Horas/Minutos",
                                    total: converter(grandTotal),
                                }}
                            />
                        </div>
                        <div className="mb-4">
                            <div className="d-flex flex-column flex-md-row">
                                <Filters
                                    startDate={{
                                        show: true,
                                        start_date: start_date,
                                        setStartDate: setStartDate,
                                        classNameFilter: "flex-1 m-3",
                                    }}
                                    endDate={{
                                        show: true,
                                        end_date: end_date,
                                        setEndDate: setEndDate,
                                        classNameFilter: "flex-1 m-3",
                                    }}
                                    station={{
                                        show: (props.me.role === ROLE_ADMIN || props.me.role === HUMAN_RESOURCES) ? true : false,
                                        station: (props.me.role === ROLE_ADMIN || props.me.role === HUMAN_RESOURCES) ? station : props.me.station,
                                        setStation: setStation,
                                        classNameFilter: "flex-1 m-3",
                                    }}
                                    user={{
                                        show: true,
                                        user: user_,
                                        setUser: setUser,
                                        classNameFilter: "flex-1 m-3",
                                    }}
                                />
                            </div>
                        </div>
                        <div className="p-0 px-3 pt-3">
                            <Grid
                                data={data}
                                loading={loader}
                                columns={columns}
                                onPageChange={customUserList}
                                noDataMessage={"Sin Usuarios"}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default reduxForm({
    form: "UnsuscribeDischargeForm",
})(List);
